import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

type Args = {
    users: ShopTypes.EditUserRequest;
    token: string | null;
};

export default function setUsersList({ users, token }: Args) {
    return shop
        .put(getUrl('/customers/users'), {
            json: users,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<ShopTypes.EditUserRequest>();
}
